import React from 'react';
import Dialog from "@material-ui/core/Dialog";
import {createAppointment, editAppointment} from "../../api";
import {connect} from "react-redux";
import {getPublicSupplierDataAction, getSupplierDataAction} from "../../store/actionCreators";
import {useParams} from "react-router-dom";
import useWizard from "../../hooks/useWizard";
import EnterDetails from "./EnterDetails";
import PaymentOptions from "./PaymentOptions";
import {ADD_NOTIFICATION} from "../../store/action";
import {useTranslation} from "react-i18next";
import {destroy} from 'redux-form';

const CreateAppointmentDialog = (props) => {
    const {t} = useTranslation()
    const {isAdmin, auth, isOpen, handleClose, editMode, appointmentId, supplierId, dispatch, getSupplierData, getPublicSupplierData, allowPayments} = props

    const handleCloseAndDestroyForm = () => {
        handleClose()
        dispatch(destroy('bookingAppointmentWizard'))
    }
    const {shortHash} = useParams()
    const refetchData = () => {
        if (isAdmin) {
            getSupplierData(auth)
        } else {
            getPublicSupplierData(shortHash)
        }
    }

    const onSubmit = (values) => {
        if (!isAdmin) {
            localStorage.setItem('customer', JSON.stringify({
                name: values.customer.name.heName,
                phone: values.customer.phone
            }))
        }
        if (editMode) {
            editAppointment({...values, supplierId, isAdmin, appointmentId}).then(() => {
                refetchData()
                dispatch({
                    type: ADD_NOTIFICATION,
                    payload: {
                        type: 'success',
                        text: t('appointment_updated')
                    }
                })
                handleCloseAndDestroyForm()
            })
        } else {
            createAppointment({...values, supplierId, isAdmin}).then(() => {
                refetchData()
                dispatch({
                    type: ADD_NOTIFICATION,
                    payload: {
                        type: 'success',
                        text: t('appointment_scheduled')
                    }
                })
                handleCloseAndDestroyForm()
            })
        }
    }
    const {activeStep, handleNext, handleBack} = useWizard({})
    const proceedToPayment = allowPayments && !isAdmin;
    return <Dialog open={isOpen} onClose={handleCloseAndDestroyForm} aria-labelledby="form-dialog-title" dir={'ltr'}
                   disableAutoFocus={true}>
        {activeStep === 0 &&
        <EnterDetails {...props} refetchData={refetchData} proceedToPayment={proceedToPayment} handleCloseAndDestroyForm={handleCloseAndDestroyForm}
                      onSubmit={proceedToPayment ? handleNext : onSubmit}/>}
        {activeStep === 1 && <PaymentOptions {...props} onSubmit={onSubmit} handleBack={handleBack}/>}
    </Dialog>
}

const mapStateToProps = (state, ownProps) => {
    const customerOptions = state.general.supplier?.customers
    const selectedCustomer = customerOptions.find(({_id}) => _id === ownProps.customerId)
    const personalData = state.general.supplier?.personalData
    return ({
        activities: state.general.supplier?.activities,
        supplierId: personalData?._id,
        activityId: ownProps.activityId,
        auth: state.general.auth,
        customerOptions,
        allowPayments: personalData?.allowPayments && personalData?.paymentId,
        initialValues: {
            dateAndTime: ownProps.dateStr,
            customer: {
                name: selectedCustomer,
                phone: selectedCustomer?.phone
            }
        },
    })
}
const mapDispatchToProps = dispatch => ({
    getSupplierData: getSupplierDataAction(dispatch),
    getPublicSupplierData: getPublicSupplierDataAction(dispatch),
    dispatch: dispatch
})


export default connect(mapStateToProps, mapDispatchToProps)(CreateAppointmentDialog);